(function () {
  // ---- Configuration ----
  // Only AU has a real free-shipping threshold in Shopify (Settings > Shipping
  // and delivery > Australia zone: free over $120 AUD). US, NZ, and Worldwide
  // are weight-based paid rates with no free tier, so their bar message is
  // static and honest rather than a price-threshold promise.
  var REGION_CONFIG = {
    AU: {
      type: 'threshold',
      threshold: 120,
      initial: 'Free shipping on all orders over {amount}',
      progress: 'Spend {amount} more for free shipping',
      achieved: 'You qualify for free shipping'
    },
    US: {
      type: 'static',
      message: "Hey USA, we've got you! 🇺🇸"
    },
    NZ: {
      type: 'static',
      message: 'Kia ora! we ship to NZ 🇳🇿'
    },
    ROW: {
      type: 'static',
      message: 'Worldwide shipping'
    }
  };

  var CURRENCY_SYMBOL = '$'; // matches your Hextom "Currency symbol: $, placed before" setting

  function countryToRegion(countryCode) {
    if (countryCode === 'NZ') return 'NZ';
    if (countryCode === 'US' || countryCode === 'CA') return 'US';
    if (countryCode === 'AU') return 'AU';
    return 'ROW';
  }

  function formatAmount(amount) {
    var rounded = Math.round(amount * 100) / 100;
    var display = rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(2);
    return CURRENCY_SYMBOL + display;
  }

  function showStatic(textEl, barEl, message) {
    textEl.textContent = message;
    barEl.style.display = 'flex';
  }

  function updateBar() {
    var barEl = document.getElementById('free-shipping-bar');
    var textEl = document.getElementById('free-shipping-bar-text');
    if (!barEl || !textEl) return;

    var region = countryToRegion(barEl.getAttribute('data-country'));
    var config = REGION_CONFIG[region];

    // Static regions (US / NZ / Worldwide) don't need cart data at all —
    // the message never changes based on cart contents.
    if (config.type === 'static') {
      showStatic(textEl, barEl, config.message);
      return;
    }

    // Threshold region (AU) — needs the live cart total to calculate progress.
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var total = cart.total_price / 100; // /cart.js returns cents
        var remaining = config.threshold - total;
        var message;

        if (total <= 0) {
          message = config.initial.replace('{amount}', formatAmount(config.threshold));
        } else if (remaining > 0) {
          message = config.progress.replace('{amount}', formatAmount(remaining));
        } else {
          message = config.achieved;
        }

        textEl.textContent = message;
        barEl.style.display = 'flex';
      })
      .catch(function () {
        // If the cart can't be fetched, hide the bar rather than show stale/wrong info.
        barEl.style.display = 'none';
      });
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', updateBar);

  // Keep the bar live: refresh after any cart-changing request, regardless of
  // which part of the theme triggers it (cart drawer, cart page, quick-add, etc.)
  // — only matters for AU in practice, but harmless to run everywhere.
  var originalFetch = window.fetch;
  window.fetch = function () {
    var request = originalFetch.apply(this, arguments);
    var urlArg = arguments[0];
    var urlString = typeof urlArg === 'string' ? urlArg : (urlArg && urlArg.url) || '';
    if (/\/cart\/(add|change|update|clear)/.test(urlString)) {
      request.then(updateBar);
    }
    return request;
  };

  // Also catch older XMLHttpRequest-based cart calls some theme code still uses
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener('load', updateBar);
    }
    return originalOpen.apply(this, arguments);
  };
})();